import { MSPanelCanvas } from "../panelcanvas/panelcanvas.js";

/**
 * @class MSPanelTab
 * @extends MSPanelCanvas
 * @classdesc ������� (������)
 * */
export class MSPanelTab extends MSPanelCanvas {
   
}